import { ElNotification, type NotificationOptions } from 'element-plus'
import { capitalize } from 'lodash-es'

export function useNotification ({ type = 'success', ...rest } = {} as Partial<NotificationOptions>) {
  if (type === 'error' && !rest.message) {
    rest.message = errorService.codes.DEFAULT.message
  }

  return ElNotification({
    ...rest,
    type,
    title: rest.title || capitalize(type),
    duration: 4000
  })
}
